import packageJson from '../../../../package.json';

import { endpointName } from './endpointName';
import { SIP_HEADER_AGENT_KEY } from './sipHeaderKey';
import { sorensonSipVersion as ssv } from './sorensonSipVersion';

export const userAgent = `${endpointName}/${packageJson.version} SSV/${ssv}`;

export const userAgentHeader = `${SIP_HEADER_AGENT_KEY}: ${userAgent}`;
